module.exports = __webpack_public_path__ + "static/redeem-3a6aef9b11c7da22770cb878274dbd18.jpg";